<template>
  <div v-if="editVertrag.inputs.length == 0" class="alert alert-info">
    Es gibt keine Variablen zum Ausfüllen. Klicken Sie auf "Speichern" um den Vertrag zu erstellen.
  </div>

  <section>
    <LoadingSpinner v-if="createOwnVariableLoading" />

    <div v-else class="w-50 mx-auto">
      <AbschnittInput
        v-for="(input, idx) in editVertrag.inputs
          .filter((a) => a.variable.herkunft.toLowerCase() != 'vertrag')
          .sort((a, b) => a.variable.gruppe.localeCompare(b.variable.gruppe))"
        :input="input"
        :index="idx"
      />
    </div>
  </section>

  <hr v-if="invalidVariablen.length > 0" class="my-4" />

  <div v-if="ownErrorMsg != ''" class="alert alert-danger">
    {{ ownErrorMsg }}
  </div>

  <div v-if="invalidVariablen.length > 0" class="w-50 mx-auto">
    <p class="fw-bold">Nicht zugeordnete Variablen</p>
    <p>Folgende Platzhalter wurden im Text gefunden, es konnten jedoch keine Variablen zugeordnet werden</p>

    <div v-for="(textvar, index) of invalidVariablen" :key="textvar" class="bg-white p-2 mb-2 border d-flex justify-content-between align-items-center">
      {{ textvar }}

      <EditVariableModal v-if="store.getters.isAdmin" :index="index + 1" :variable="getVariableType(textvar)" @variable-created="atVariableCreated" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, ref } from 'vue';
  import { useStore } from '@/store';

  import { Vertrag, Input } from '@/models/VertragModels';
  import { Variable } from '@/models/VorlageModels';

  import AbschnittInput from '../AbschnittInput.vue';
  import EditVariableModal from '@/components/Vorlagen/EditVariableModal.vue';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  //#endregion

  const { editVertrag, invalidVariablen } = defineProps({
    editVertrag: {
      type: Object as PropType<Vertrag>,
      required: true,
    },

    invalidVariablen: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  });

  const store = useStore();
  const ownErrorMsg = ref('');
  const createOwnVariableLoading = ref(false);

  function getVariableType(textvar: string): Variable {
    var newVariable = new Variable();

    newVariable.platzhalter = textvar;
    newVariable.titel = textvar.substring(2, textvar.length - 2);

    return newVariable;
  }

  function atVariableCreated(platzhalter: string) {
    ownErrorMsg.value = '';
    createOwnVariableLoading.value = true;
    console.log(platzhalter);

    // create and add new input
    const variable = store.getters.variablen.find((v) => v.platzhalter === platzhalter);
    if (variable != null) {
      const newInput = new Input(variable.id, variable, editVertrag.id, '');
      editVertrag.inputs.push(newInput);
      console.log('INPUTS', editVertrag.inputs);
    } else {
      ownErrorMsg.value = `Es ist ein unerwarteter Fehler beim Erstellen der Variable mit Platzhalter "${platzhalter}" aufgetreten.`;
      return;
    }

    // remove from invalidVariablen
    const index = invalidVariablen.indexOf(platzhalter);
    if (index > -1) {
      invalidVariablen.splice(index, 1);
    }
    createOwnVariableLoading.value = false;
  }
</script>
